var scope_0 = require('/Users/marcysutton/Sites/FrontendMasters/js-a11y/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7627bb210d4617a2b670a943c38f4fb3.js').default;export default
        Object.assign({}, scope_0 )
    